import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../auth.jsx'
import { PageContainer } from '@ui'

export function CallbackPage() {
  const { handleCallback } = useAuth()
  const nav = useNavigate()
  useEffect(() => {
    handleCallback()
      .then(() => nav('/orgs', { replace: true }))
      .catch(() => nav('/', { replace: true }))
  }, [handleCallback, nav])
  return <PageContainer><p>Signing in…</p></PageContainer>
}
